import { createSlice } from '@reduxjs/toolkit'

export const integrationSlice = createSlice( {
  name:         'integration',
  initialState: {
    stripe:       {
      publicKey: ''
    },
    isConnecting: false
  },
  reducers:     {
    setConnecting:      ( state, action ) => {
      state.isConnecting = action.payload
    },
    setStripePublicKey: ( state, action ) => {
      state.stripe.publicKey = action.payload
    }
  }
} )

// Action creators are generated for each case reducer function
export const { setConnecting, setStripePublicKey } = integrationSlice.actions

export default integrationSlice.reducer